import CustomToolTip from '@Components/Tooltips/CustomToolTip'
import React from 'react'

const MailingAddressToolTip = () => (
    <CustomToolTip
        type="i"
        info={
            'Please enter your personal address. This information is used' +
            " to verify your identity. Once you are registered as a user, you'll be able to use your business" +
            ' information to create a Member and start managing your works.'
        }
    />
)
export default MailingAddressToolTip
